import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const TreeWrapper = styled.div`
	height: 100%;
	width: 100%;

	.rstcustom__rowLabel {
		cursor: pointer;
	}

	.rstcustom__rowTitle {
		font-weight: 400;
		letter-spacing: 0.3px;
	}

	.rstcustom__rowContents {
		box-shadow: none;
		background: transparent;
		position: inherit;
	}

	.rstcustom__highlight {
		background: transparent;

		.rstcustom__rowTitle {
			font-weight: bold;
			letter-spacing: 0.21px;
		}
	}

	.node-selected {
		background: ${colors.white};
	}

	.rstcustom__rowSearchFocus {
		outline: none;
	}

	.node-selected .rstcustom__rowTitle,
	.rstcustom__rowSearchFocus .rstcustom__rowTitle {
		font-weight: bold;
		letter-spacing: 0.21px;
	}

	.rstcustom__expandButton:before,
	.rstcustom__collapseButton:before {
		position: relative;
		left: -34px;
		content: '';
		background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzFBMUExQSI+PHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik0xMCA2TDguNTkgNy40MSAxMy4xNyAxMmwtNC41OCA0LjU5TDEwIDE4bDYtNnoiLz48L3N2Zz4=)
			no-repeat center;
		width: 12px;
		height: 12px;
		display: inline-block;
	}

	.rstcustom__collapseButton:before {
		background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzFBMUExQSI+PHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik0xNi41OSA4LjU5TDEyIDEzLjE3IDcuNDEgOC41OSA2IDEwbDYgNiA2LTZ6Ii8+PC9zdmc+)
			no-repeat center;
	}

	.rstcustom__rowWrapper {
		display: flex;
	}
`;

export const ItemWrapper = styled.div`
	display: flex;
	color: black;
	align-items: center;
	width: 100%;
`;

export const ItemLevel = styled.div`
	font-size: 11px;
	line-height: 13px;
	color: ${colors.grey4};
	margin-right: 5px;
`;

export const ItemTitle = styled.div`
	font-size: 13px;
	line-height: 19px;
	margin-right: 12px;

	${({ level }) => `width: ${310 - level * 20}px;`};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const ItemIcon = styled.div`
	width: 6px;
	height: 6px;
	border-radius: 100%;
	background: ${colors.grey8};
	position: relative;
	left: -12px;
`;
